import { render, staticRenderFns } from "./xsyz_list.vue?vue&type=template&id=4c99169b&scoped=true"
import script from "./xsyz_list.vue?vue&type=script&lang=ts"
export * from "./xsyz_list.vue?vue&type=script&lang=ts"
import style0 from "./xsyz_list.vue?vue&type=style&index=0&id=4c99169b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c99169b",
  null
  
)

export default component.exports